import React, { useEffect, useRef, useState } from 'react';

const useTimeCountdownToGetTimes = (endDate) => {
    const [timerDays, setTimerDays] = useState('00')
    const [timerHours, setTimerHours] = useState('00')
    const [timerMinutes, setTimerMinutes] = useState('00')
    const [timerSeconds, setTimerSeconds] = useState('00')

    let interval = useRef();

    const startTimer = () => {
        const countDownDate = new Date(endDate).getTime();

        interval = setInterval(() => {
            const now = new Date().getTime();
            const distance = countDownDate - now;

            const days = Math.floor(distance / (1000 * 60 * 60 * 24))
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)))
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
            const seconds = Math.floor((distance % (1000 * 60)) / 1000)

            if (distance < 0) {
                clearInterval(interval.current)
            }
            else {
                setTimerDays(('0' + days).slice(-2));
                setTimerHours(('0' + hours).slice(-2));
                setTimerMinutes(('0' + minutes).slice(-2));
                setTimerSeconds(('0' + seconds).slice(-2));
            }
        }, 1000)
    }

    useEffect(() => {
        startTimer()
        return () => {
            clearInterval(interval.current)
        }
    })





    return {
        timerDays,
        timerHours,
        timerMinutes,
        timerSeconds,
    }
};

export default useTimeCountdownToGetTimes;